import React from 'react'
import './ui.css'

/**
 * Выпадающий список. Тот же визуальный ряд, что и Input (высота, border, radius, шрифт).
 */
function Select({ className = '', ...props }) {
  return <select className={'ui-select' + (className ? ` ${className}` : '')} {...props} />
}

export default Select
